module.exports = __webpack_public_path__ + "static/media/Data Enrichment@4x.de1448ba.png";